export default __webpack_public_path__ + "static/media/skyandsonslogo.73e6b9ac.jpg";